import React from 'react';
import { Box, Typography } from '@mui/material';
import { CustomButton } from '../../../v2/MUI_custom_component';

const BusinessExpiryInventoryCard = ({
  bagText = '--',
  expiryDaysText = '--',
  onViewInventory,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        gap: '16px',
        padding: '8px',
        borderRadius: '16px',
        backgroundColor: '#fff',
        maxWidth: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '163px',
          height: '136px',
          borderRadius: '16px',
          backgroundColor: '#C62828',
          flexShrink: 0,
          gap: '16px',
        }}
      >
        <Typography
          variant=''
          sx={{
            color: '#fff',
          }}
        >
          {bagText}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          flex: 1,
          justifyContent: 'center',
        }}
      >
        <Typography
          variant='labelM'
          sx={{
            color: '#333333',
          }}
        >
          Expiring in {expiryDaysText} days!
        </Typography>
        <Typography
          variant='Body1'
          sx={{
            color: '#333333',
          }}
        >
          Allocate your inventory to avail benefits. To sell click on the
          button.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 'auto' }}>
          <CustomButton
            variant='filled'
            color='primary'
            label='View Inventory'
            onClick={onViewInventory}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default BusinessExpiryInventoryCard;
